import { createApp } from "vue";
import VueLoading from 'vue-loading-overlay';
import 'vue-loading-overlay/dist/vue-loading.css';
import App from "./App.vue";
import router from "./router";

createApp(App).use(router).use(VueLoading).mount("#app");
